<div class="img-wrapper">
    <div class="front">
        <a [routerLink]="['/product/', products.handleUrl]">
            <img alt="" class="img-fluid" [src]="products.image[0]?.url">
        </a>
    </div>
    <div class="cart-info cart-wrap">
        <!-- <button (click)="addToCart(products)" title="Add to cart"><i class="fa fa-shopping-cart" ></i></button>
        <a (click)="addToWishlist(products)" title="Add to Wishlist"><i class="fa fa-heart-o" aria-hidden="true"></i></a>
        <a routerLinkActive="active" (click)="addToCompare(products)" title="Compare"><i class="fa fa-refresh"aria-hidden="true"></i></a> -->
        <a href="javascript:void(0)" title="Hızlı İncele" (click)="openQuickPreview(products.id)"><i class="fa fa-search" aria-hidden="true"></i></a>
    </div>
</div>

<div *ngIf="learnshow == 1">
    <div class="product-detail">
        <a [routerLink]="['/product/', products.handleUrl]">
            <h6>{{products.title}}</h6>
        </a>
        <p>{{products.subtitle}}</p>
        <h4 *ngIf="products.showPrice">{{products.displayPrice}} TL</h4>
        <div *ngIf="!products.showPrice">
            <a (click)="requestPrice(products.id)">
                <button class="btn btn-default primary-btn back-white radius-0 w-100 fbtn">
                    Fiyat İste
                </button>
            </a>
        </div>
    </div>
</div>

<h6 *ngIf="learnshow == 0" class="text-center my-3">{{products.title}}</h6>
<h4 *ngIf="learnshow == 0" class="text-center">{{products.displayPrice}} TL</h4>